import React, { useEffect, useState } from 'react'
import { HeaderSubtitleCentered, Jobs } from 'newComponents'
import './styles.scss'

const JobsContainer = (props) => {
  const [data, setData] = useState(null)

  const fetchData = async () => {
    const url = 'https://boards-api.greenhouse.io/v1/boards/launchdarkly/jobs?content=true'
    const res = await fetch(url)
    res.json().then((res) => setData(res.jobs))
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <section className="section is-large open-positions" id="open-positions">
      <div className="container" id="jobs-container">
        <HeaderSubtitleCentered
          header="Open Positions"
          subtitle=" Want to help change how modern dev teams develop and ship products?"
        />
        <Jobs jobs={data} />
      </div>
    </section>
  )
}

export default JobsContainer
